import { BsPlus } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const DietsToolbar = ({ setSearchText }) => {
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    setSearchText(value);
  };

  return (
    <div className="flex justify-between items-center mb-4">
      <div className="relative">
        <FiSearch
          size={16}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        />
        <input
          type="text"
          placeholder="Search diets"
          className="border pl-9 pr-3 py-2 rounded text-sm input-field"
          value={searchValue}
          maxLength={256}
          onChange={handleSearchChange}
        />
      </div>

      <button
        className="btn-add px-4"
        title="Add"
        onClick={() => navigate("/diet-master/add")}
      >
        <BsPlus size={26} color="#ffffff" /> Diet
      </button>
    </div>
  );
};

export default DietsToolbar;
